export { default } from './MenuSeccio';
